import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.accident;

export const getAccidentPlansSelector = createSelector(getState, (state) => state.accidentPlans);
